module.exports = __webpack_public_path__ + "english-vertical-banner-f5086dfcb240b63326f1.png";